import { call, put } from 'redux-saga/effects';
import { API } from '../../api';

export function* fetchCities() {
  const path = '/users/cities';
  const results = yield call(API, 'get', 'api', path);

  yield put({
    type: 'SET_CITIES',
    payload: {
      cities: results.cities,
    },
  });
}
